import { Modal } from "antd";

export const alertify = (title, content, type, options = {}) => {
    Modal[type]({
        className: options.hideFooter ? "no-alertify-buttons" : "",
        title: title,
        content: content,
        centered: true,
        okText: options.okText || "Ok",
        onOk: options.onOk,
        closable: options.closable,
        cancelText: options.cancelText || "Close",
        onCancel: options.onCancel,
    });
};


export const openNotificationWithIcon = (api, type, message, description) => {
    api[type]({
        message: message,
        description: description,
    });
};


export const validateAmount = (minAmount) => (_, value) => {
    if (!value) {
        return Promise.reject('Please enter payable amount')
    }

    const floatValue = parseFloat(value);

    if (isNaN(floatValue) || floatValue < minAmount) {
        return Promise.reject(`Please enter a valid amount greater than ${minAmount}`);
    }
    return Promise.resolve();
};

export const titlize = (str) => {
    return str
        .toUpperCase()
        .split(" ")
        .map((word) => {
            return word.replace(word[0], word[0].toUpperCase());
        })
        .join(" ");
};


export const maskMobileNumber = (mobileNumber) => {
    if (!mobileNumber || typeof mobileNumber !== 'string') {
        return mobileNumber
    }

    if (mobileNumber.length < 10) {
        return mobileNumber
    }

    const firstDigit = mobileNumber[0];
    const lastThreeDigits = mobileNumber.slice(-3);

    const maskedMiddle = mobileNumber.slice(1, -3).replace(/\d/g, '*');
    const maskedNumber = `${firstDigit}${maskedMiddle}${lastThreeDigits}`;
    return maskedNumber;
}


export const maskEmail = (email) => {
    if (!email || typeof email !== 'string') {
        return email;
    }

    const [localPart, domainPart] = email.split('@');
    const unmaskedLocalPart = localPart.slice(0, 3) + localPart.slice(3, -4).replace(/./g, '*') + localPart.slice(-4);
    const unmaskedEmail = `${unmaskedLocalPart}@${domainPart}`;
    return unmaskedEmail;
}
